import { AddAdminJobDetailPayload } from "../../../../models/Job";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";

import mutationWrapper from "../../mutationWrapper";
import { fetchAdminAllJobKey } from "../../queries/Job/useFetchAdminAllJob";
import getQueryClient from "../../queryClient";

export async function addJob(data: AddAdminJobDetailPayload) {
  const res = await ApiClient.post(`/AddJob`, data);
  return res.data;
}

export const useAddJob = mutationWrapper(addJob, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(fetchAdminAllJobKey);
  },
});
